f<template>
	<div class="goods">
		<!--顶部搜索框 -->
		<div class="nav">
			<van-icon name="arrow-left" size="1.2rem" color="#fff" @click="back" />
			<van-col span="24">
				<van-search v-model="value" @focus="serch" placeholder="您喜欢的" shape="round" background="#f1452f" />
			</van-col>
		</div>
		<!-- 综合列表 -->
		<van-row class="dropdown">
			<van-col span="5" @click="toggTab(1)" :class="{active : flag==1}">
				<span class="esp">综合</span>
			</van-col>
			<van-col span="5" @click="toggle" :class="{active : flag==5 || flag==6}">
				<div class="esp">
					<span>价格</span>
					<img v-if="flag==5" src="../../assets/up.png" alt="">
					<img v-else-if="flag==6" src="../../assets/down.png" alt="">
					<img v-else src="../../assets/default.png" alt="">
				</div>
			</van-col>
			<van-col span="5" @click="toggTab(7)" :class="{active : flag==7}">
				<span class="esp">销量</span>
			</van-col>
			<!-- <van-col span="5" @click="show=true" :class="{active : show==true}">
        <span class="esp">筛选</span>
      </van-col> -->
			<!-- <van-popup v-model="show" close-on-click-overlay position="right" :style="{ height: '100%', width: '85%' }">
        <div class="popup-top">
          <van-panel title="购买方式">
            <van-row type="flex" justify="space-around">
              <van-col :class="{'popup-active': category_id==1}" @click="category_id=1" span="6">品牌租赁</van-col>
              <van-col :class="{'popup-active': category_id==2}" @click="category_id=2" span="6">特价销售</van-col>
              <van-col :class="{'popup-active': category_id==3}" @click="category_id=3" span="6">精品二手</van-col>
            </van-row>
          </van-panel>
        </div>
        <div class="popup-bottom">
          <div>
            <van-panel title="风格">
              <van-row class="screen_brand">
                <van-col v-for="(item,index) in screen_brand.style" :class="{'popup-active': style_id==item.id}" @click="style_id==item.id ? style_id = '' : style_id=item.id">{{item.title}}</van-col>
              </van-row>
            </van-panel>
            <van-panel title="品牌">
              <van-row class="screen_brand">
                <van-col v-for="(item,index) in screen_brand.brand" :class="{'popup-active': brand_id==item.id}" @click="brand_id==item.id ? brand_id = '' : brand_id=item.id">{{item.title}}</van-col>
              </van-row>
            </van-panel>
          </div>
        </div>
        <div class="popup-btn">
          <van-button round size="small" type="default" @click="reset">重置</van-button>
          <van-button color="#f1452f" round size="small" type="info" @click="submit">确定</van-button>
        </div>
      </van-popup> -->
		</van-row>
		<div class="container">
			<van-sidebar v-model="activeKey">
				<van-sidebar-item @click="getCatId('')" title="全部" />
				<van-sidebar-item @click="getCatId(item.id)" :title="item.title" v-for="item in screen_brand" />
			</van-sidebar>
			<!--商品列表 -->
			<div v-if="none" class="none">
				<div id="listgundo">暂无数据~</div>
				<van-button color="#f1452f" size="mini" round to="/Home">去逛逛</van-button>
			</div>
			<van-list id="listgundo" v-model="loading" finished-text="我是有底线的" @load="onLoad" v-else>
				<ul class="left-waterfall" ref="left">
					<li class="item" v-for="(item, index) in leftItems" @click="setParams(item.id)">
						<img :src="item.image[0] | handleUrl" alt="">
						<div class="main">
							<div class="main-title">{{item.title}}</div>
							<div class="main-tag">
								<span class="primary" v-if="item.category==1">个人转让</span>
								<span class="primary" v-else>商家出售</span>
								<span class="primary">{{item.new_old}}</span>
							</div>
							<div class="vangrid-right">
								<div class="taido">
									<span class="f1452f font-5">{{item.price | formarter}}</span>
									<span>{{item.city}}</span>
								</div>
								<div>距离您{{item.km}}km</div>
							</div>
						</div>
					</li>
				</ul>
				<ul class="right-waterfall" ref="right">
					<li class="item" v-for="(item, index) in rightItems" @click="setParams(item.id)">
						<img :src="item.image[0] | handleUrl" alt="">
						<div class="main">
							<div class="main-title">{{item.title}}</div>
							<div class="main-tag">
								<span class="primary" v-if="item.category==1">个人转让</span>
								<span class="primary" v-else>商家出售</span>
								<span class="primary">{{item.new_old}}</span>
							</div>
							<div class="vangrid-right">
								<div class="taido">
									<span class="f1452f font-5">{{item.price | formarter}}</span>
									<span>{{item.city}}</span>
								</div>
								<div>距离您{{item.km}}km</div>
							</div>
						</div>
					</li>
				</ul>
				<div style="clear:both"></div>
			</van-list>
		</div>
		<Footbar></Footbar>
	</div>
</template>

<script>
	import Footbar from '@/components/trade';

	export default {
		name: 'home_undete',
		data() {
			return {
				activeKey: 0,
				loading: false,
				finished: false,
				none: false,
				immediate_check: false,
				flag: 1, //导航条件
				show: false,
				//商品列表
				goods: [],
				leftItems: [],
				rightItems: [],
				brand: [],
				page: 1,
				value: '',
				screen_brand: [],
				category_id: 1,
				style_id: '',
				cat_id: '',
				brand_id: '',
			}
		},
		components: {
			Footbar
		},
		created() {
			//加载筛选条件
			this.$axios.post(baseUrl + '/mobile/Fta/ftaCategory').then((res) => {
				if (res.data.code == 2) {
					this.screen_brand = res.data.data;
					this.cat_id = 0;
					this.getCatId(this.cat_id);
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		methods: {
			updateWaterfall() {
				const leftHeight = this.leftItems.length
				const rightHeight = this.rightItems.length
				let item = this.goods.shift();
				if (item == null) {
					return
				}
				if (item != undefined) {
					if (leftHeight <= rightHeight) {
						this.leftItems.push(item)
					} else {
						this.rightItems.push(item)
					}
					this.$nextTick(function() {
						this.updateWaterfall()
					})
				}
			},
			//初始化数据列表
			getTitle() {
				this.$axios.post(baseUrl + '/mobile/Fta/fta', {
					id: this.cat_id,
					page: this.page,
					limit: 10,
					lng: this.$store.state.location[0],
					lat: this.$store.state.location[1]
				}).then((res) => {
					if (res.data.code == 2) {
						this.page = 2;
						this.none = false;
						this.goodsShow();
						setTimeout(() => {
							this.goods = res.data.data;
							this.updateWaterfall();
						}, 500)
					} else {
						this.none = true;
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			// 异步更新数据
			onLoad() {
				this.$axios.post(baseUrl + '/mobile/Fta/fta', {
					id: this.cat_id,
					page: this.page,
					limit: 10,
					lng: this.$store.state.location[0],
					lat: this.$store.state.location[1]
				}).then((res) => {
					if (res.data.code == 2) {
						this.page++;
						setTimeout(() => {
							if (this.page > 2) {
								for (var i in res.data.data) {
									this.goods.push(res.data.data[i])
								}
							}
							// 加载状态结束
							this.loading = false;
							this.updateWaterfall()
						}, 500)
					} else {
						this.loading = false;
						this.finished = true;
					}
				}).catch((err) => {
					console.log(err);
				});

			},
			//条件切换
			toggTab(fa) {
				this.flag = fa;
				this.page = 1;
				this.getTitle();
			},
			//价格切换
			toggle() {
				if (this.flag != 5) {
					this.flag = 5
				} else if (this.flag == 5) {
					this.flag = 6
				}
				this.page = 1;
				this.getTitle();
			},
			//切换导航数据
			goodsShow() {
				this.finished = false;
				this.leftItems = [];
				this.rightItems = [];
			},
			//跳转详情页
			setParams(em) {
				this.$router.push({
					path: '/undeteDteil',
					query: {
						id: em
					}
				})
			},
			//提交筛选条件
			submit() {
				this.page = 1;
				this.show = false;
				this.getTitle();
			},
			//重置
			reset() {
				this.category_id = 1;
				this.style_id = '';
				this.brand_id = '';
			},
			//侧边导航栏切换
			getCatId(id) {
				this.page = 1;
				this.cat_id = id;
				this.getTitle();
			}
		},
		watch: {
			'$route'(to, from) {
				if (to.name === 'home_undete') { //跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
					let savehdjkG = this.$store.state.savehdjhaY;
					//把在vuex里面的位置存入
					document.getElementById('listgundo').scrollTop = savehdjkG
				}
			}
		},
		beforeRouteLeave(to, from, next) {
			//获取滚动条的高度
			let position = document.getElementById('listgundo').scrollTop;
			//离开路由存起来
			if (position == null) position = 0
			this.$store.commit('savehdjkG', position) //离开路由时把位置存起来
			next()
		},

	}
</script>

<style scoped>
	@import '../pages/pages.css';

	.taido span:nth-child(2) {
		position: relative;
		top: 0.3rem;
	}

	.goods {
		height: calc(100% - 2rem);
		box-sizing: border-box;
		padding-bottom: 3rem;
		overflow: hidden;
	}

	.goods .van-list .main .vangrid-right span[data-v-241cdcea]:nth-child(2) .goods .none {
		font-size: 0.75rem;
		color: #B0B0B0;
		margin-top: 5rem;
		width: calc(100% - 4rem);
	}

	.goods .none button {
		padding: 0 1rem;
		margin-top: 0.5rem;
	}

	.goods .dropdown {
		margin-bottom: 0.4rem;
		position: fixed;
		width: 100%;
		z-index: 2019;
	}

	.goods .dropdown span {
		font-size: 0.8rem;
	}

	.goods .container {
		display: flex;
		padding-top: 3rem;
		height: 100%;
		box-sizing: border-box;
	}

	/* 手机端样式 */

/* 	.goods .container {
		display: flex;
		padding-top: 3rem;
		height: 106%;
		box-sizing: border-box;
	} */

	.goods .van-list {
		width: calc(100% - 4rem);
		height: 100%;
		box-sizing: border-box;
		background: #f2f2f2;
		padding: 0 0.35rem;
		overflow-y: scroll;
		box-sizing: border-box;
	}

	.goods .van-list .main .font-5 {
		font-size: 0.8rem;
	}

	.goods img {
		width: 100%;
		object-fit: contain;
	}

	.van-sidebar {
		height: 100%;
		overflow-y: scroll;
	}

	.van-sidebar a {
		padding: 0.75rem 0;
	}

	.van-sidebar-item--select {
		color: #F1452F;
	}

	.van-tag {
		padding: 0.1rem;
	}

	.goods .main-tag {
		font-size: 0.75rem;
		margin: 0.5rem 0;
	}

	.goods .main-title {
		font-size: 0.8rem;
	}

	.goods .danger {
		color: #F1452F;
		border: 1px solid #F1452F;
		border-radius: 0.2rem;
		padding: 0 0.2rem;
	}

	.goods .primary {
		color: #3ea6ef;
		border: 1px solid #3ea6ef;
		border-radius: 0.2rem;
		font-size: 12px;
		padding: 0 0.2rem;
		margin-right: 0.2rem;
	}

	.goods .van-list .main .vangrid-right {
		display: block;
	}

	.goods .van-list .main .vangrid-right div:nth-child(1) {
		width: 90%;
		display: flex;
		justify-content: space-between;
	}

	.goods .van-list .main .vangrid-right div:nth-child(2) {
		margin-top: 0.2rem;
	}

	.none {
		width: 100%;
		margin-top: 2rem;
		text-align: center;

	}
</style>



// WEBPACK FOOTER //
// src/components/home/home_undete.vue